<ag-grid-angular
  class="grid-container"
  [gridOptions]="gridOptions"
  [rowData]="rowData"
  [columnDefs]="colDefs"
  [defaultColDef]="defaultColDef"
/>
